









import { Component, Vue, Prop } from 'vue-property-decorator';
import { Tweet, Type } from '../models/tweet';

@Component
// XxxComponentのような命名規則ではないがTweetモデルとクラス名が被るので。
export default class TweetComponent extends Vue {

  @Prop() private tweet!: Tweet;

}
